import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTENT_DIRECTION } from '../../constants/contentDirection';
import AssessmentSumProgressBar from './AssessmentSumProgressBar';
import { TraitScore } from '../../models/applications';

interface AssessmentSumProgressBlockProps {
  scores: TraitScore[];
  isAppendixPage: boolean;
}

const AssessmentSumProgressBlock = ({
  scores,
  isAppendixPage,
}: AssessmentSumProgressBlockProps) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem('contentDirection');

  const customTraits = scores.filter((item) => item.trait.group_id === null);
  const hasExecuteGroup = scores.some((item) => item.trait.group_id === 3);
  const hasEngageGroup = scores.some((item) => item.trait.group_id === 2);
  const hasEvolveGroup = scores.some((item) => item.trait.group_id === 1);

  const GroupBlock = ({
    groupId,
    title = '',
    description = '',
    customClass = '',
  }: {
    groupId: number;
    title?: string;
    description?: string;
    customClass?: string;
  }) => (
    <div className={`progress-report ${customClass}`}>
      <p>
        <span>{t(title)}</span>
        {t(description)}
      </p>
      {scores
        .filter((item) => item.trait.group_id === groupId)
        .map((item) => (
          <AssessmentSumProgressBar
            key={item.trait.id}
            item={item}
            customTraitsCount={customTraits.length}
            showProgressBar={!isAppendixPage}
          />
        ))}
    </div>
  );

  return (
    <section className="assessment-sec page-break">
      {isAppendixPage ? (
        <h2 className="progress-report-heading">{t('Appendix Page Head')}</h2>
      ) : (
        <h2 className="progress-report-heading">{t('Assessment Summary')}</h2>
      )}
      {customTraits.length === 0 || isAppendixPage ? (
        <div className="d-flex flex-wrap">
          <div className="pr-3 w-50 progress-report-section">
            {hasEvolveGroup && (
              <GroupBlock
                groupId={1}
                title={t('Evolve')}
                description={t('Creating for success')}
              />
            )}
            {hasExecuteGroup && hasEngageGroup && (
              <GroupBlock
                groupId={3}
                title={t('Execute')}
                description={t('Getting the job done')}
                customClass={hasEvolveGroup ? 'progress-report-execute' : ''}
              />
            )}
          </div>
          <div
            className={`${
              direction === CONTENT_DIRECTION.RTL ? 'pr-3' : 'pl-3'
            } w-50`}
          >
            {hasEngageGroup && (
              <GroupBlock
                groupId={2}
                title={t('Engage')}
                description={t('Bringing people along')}
              />
            )}
            {hasEvolveGroup && hasExecuteGroup && !hasEngageGroup && (
              <GroupBlock
                groupId={3}
                title={t('Execute')}
                description={t('Getting the job done')}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex flex-wrap">
          {customTraits.map((item, i) => (
            <div className="pr-3 w-50">
              <div className="progress-report-custom">
                <AssessmentSumProgressBar
                  key={item.trait.id}
                  item={item}
                  customTraitsCount={customTraits.length}
                  showProgressBar={!isAppendixPage}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AssessmentSumProgressBlock;
